import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

const CurrentPlayers = ({ users, mobile_app }) => {
  const nameVariants = {
    hidden: { opacity: 0, scale: 0.3 },
    visible: { opacity: 1, scale: [1.1, 0.9, 1.03, 0.97, 1] },
    exit: { opacity: [1, 1, 0], scale: [0.9, 1.1, 0.3] },
  };

  return (
    <div className={`overflowScroll ${mobile_app ? "mobile-cnt" : "web-cnt"}`}>
      {users.map((user) => (
        <motion.div variants={nameVariants} key={user.player_id} className="GiovanniInput">
          <p className="mediamText darkBlueText m-0">{user.display_name}</p>
        </motion.div>
      ))}
    </div>
  );
};

export default CurrentPlayers;
